import moment from "moment";
export const MomentConvert = (date) => {
  return moment(date).format("DD/MM/YYYY HH:mm");
};
